import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full shadow-2xl">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-2">
            Pagamento Annullato
          </h1>
          
          <p className="text-slate-600 mb-8">
            Il pagamento è stato annullato. Nessun addebito è stato effettuato sul tuo conto.
          </p>

          <div className="bg-slate-50 rounded-xl p-6 mb-8">
            <h3 className="font-semibold text-slate-900 mb-3">Cosa puoi fare:</h3>
            <ul className="text-left text-slate-600 space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-blue-600">•</span>
                Tornare indietro e riprovare il pagamento
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600">•</span>
                Verificare i dettagli della tua carta
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600">•</span>
                Contattare il supporto se il problema persiste
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <Button
              onClick={() => navigate(-1)}
              className="w-full h-12 bg-blue-600 hover:bg-blue-700"
            >
              <RefreshCw className="w-5 h-5 mr-2" />
              Riprova il pagamento
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full h-12"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Torna alla Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
